import React from "react";
import Select from "react-select";
import { CheckCircle2, ShieldAlert, X } from "lucide-react";

const AddRestrictionModal = ({
  t,
  restrictionForm,
  restrictionErrors,
  selectedRestrictionType,
  restrictionTypeOptions,
  CategoryOption,
  selectStyles,
  updateRestrictionField,
  setRestrictionForm,
  restrictionEligibilityReason,
  isRestrictionSubmitDisabled,
  restrictionSubmitLoading,
  onClose,
  onSubmit,
}) => (
  <div className="strike-modal-backdrop strike-form-modal-backdrop" role="presentation">
    <form className="strike-panel strike-form-modal restriction-panel" onSubmit={onSubmit} role="dialog" aria-modal="true" aria-labelledby="restriction-form-title">
      <div className="strike-panel-header">
        <div>
          <h3 className="strike-panel-title" id="restriction-form-title">{t("applyStrike.restriction.title")}</h3>
          <p className="strike-panel-subtitle">{t("applyStrike.restriction.subtitle")}</p>
        </div>
        <button type="button" className="strike-close-btn" onClick={onClose} aria-label={t("applyStrike.restriction.closeForm")}>
          <X size={18} />
        </button>
      </div>

      <div className="modalbody-scroll-bar">
        <div className="restriction-alert">
          <ShieldAlert size={20} />
          <div>
            <strong>{t("applyStrike.restriction.thresholdTitle")}</strong>
            <span>{restrictionEligibilityReason}</span>
          </div>
        </div>

        <div className="strike-form-grid">
          <div className="strike-field strike-field-full" data-field="restriction_type">
            <label className="strike-field-label" htmlFor="restriction-type">
              {t("applyStrike.restriction.type")} <span className="strike-required">*</span>
            </label>
            <Select
              inputId="restriction-type"
              classNamePrefix="strike-select"
              options={restrictionTypeOptions}
              value={selectedRestrictionType}
              onChange={(option) => updateRestrictionField("restriction_type", option?.value || "")}
              components={{ Option: CategoryOption }}
              styles={selectStyles}
              placeholder={t("applyStrike.restriction.placeholders.type")}
              aria-invalid={!!restrictionErrors.restriction_type}
            />
            {restrictionErrors.restriction_type ? <span className="strike-error">{restrictionErrors.restriction_type}</span> : null}
          </div>

          <div className="strike-field strike-field-full" data-field="restriction_reason">
            <label className="strike-field-label" htmlFor="restriction-reason">
              {t("applyStrike.reason")} <span className="strike-required">*</span>
            </label>
            <input
              id="restriction-reason"
              type="text"
              className="strike-input"
              value={restrictionForm.reason}
              onChange={(event) => updateRestrictionField("reason", event.target.value)}
              placeholder={t("applyStrike.restriction.placeholders.reason")}
            />
            {restrictionErrors.reason ? <span className="strike-error">{restrictionErrors.reason}</span> : null}
          </div>

          <div className="strike-field strike-field-full">
            <label className="strike-field-label" htmlFor="restriction-description">
              {t("applyStrike.description")}
            </label>
            <textarea
              id="restriction-description"
              className="strike-textarea"
              rows="4"
              value={restrictionForm.description}
              onChange={(event) => updateRestrictionField("description", event.target.value)}
              placeholder={t("applyStrike.restriction.placeholders.description")}
            />
          </div>

          <div className="strike-field">
            <label className="restriction-switch">
              <input
                type="checkbox"
                checked={restrictionForm.permanent}
                onChange={(event) => {
                  const checked = event.target.checked;
                  setRestrictionForm((prev) => ({
                    ...prev,
                    permanent: checked,
                    expires_at: checked ? "" : prev.expires_at,
                  }));
                }}
              />
              <span />
              <strong>{t("applyStrike.restriction.permanent")}</strong>
            </label>
          </div>

          <div className={`strike-field ${restrictionForm.permanent ? "strike-field-disabled" : ""}`}>
            <label className="strike-field-label" htmlFor="restriction-expires">
              {t("applyStrike.restriction.expiresAt")}
            </label>
            <input
              id="restriction-expires"
              type="date"
              className="strike-input"
              value={restrictionForm.expires_at}
              disabled={restrictionForm.permanent}
              onChange={(event) => updateRestrictionField("expires_at", event.target.value)}
            />
          </div>
        </div>
      </div>

      <div className="strike-form-actions">
        <div className="strike-submit-helper">
          {isRestrictionSubmitDisabled ? t("applyStrike.restriction.completeRequired") : t("applyStrike.restriction.ready")}
        </div>
        <div className="strike-action-buttons">
          <button type="button" className="strike-btn-cancel" onClick={onClose}>
            {t("applyStrike.cancel")}
          </button>
          <button type="submit" className="strike-btn-submit" disabled={isRestrictionSubmitDisabled}>
            {restrictionSubmitLoading ? t("applyStrike.restriction.applying") : t("applyStrike.restriction.title")}
            {!restrictionSubmitLoading ? <CheckCircle2 size={17} /> : null}
          </button>
        </div>
      </div>
    </form>
  </div>
);

export default AddRestrictionModal;
